export const composeItemDefs = (collection) => {
  switch (collection) {
    case 'deakin-university~sp-events':
      return [
        {
          funnelbackField: 'listMetadata.id[0]',
          columnKey: 'id',
        },
        {
          funnelbackField: 'listMetadata.heading[0]',
          columnKey: 'heading',
        },
        {
          funnelbackField: 'listMetadata.location',
          columnKey: 'location',
        },
        {
          funnelbackField: 'listMetadata.url[0]',
          columnKey: 'url',
        },
        {
          funnelbackField: 'listMetadata.imageUrl[0]',
          columnKey: 'imageUrl',
        },
        {
          funnelbackField: 'listMetadata.startDate[0]',
          columnKey: 'startDate',
        },
        {
          funnelbackField: 'listMetadata.endDate[0]',
          columnKey: 'endDate',
        },
        {
          funnelbackField: 'listMetadata.isExternalLink[0]',
          columnKey: 'externalLink',
        },
        {
          funnelbackField: 'listMetadata.alt[0]',
          columnKey: 'alt',
        },
      ];

    // PEER SUPPORT
    case 'deakin-university~sp-peer-support':
      return [
        {
          funnelbackField: 'listMetadata.id[0]',
          columnKey: 'id',
        },
        {
          funnelbackField: 'listMetadata.heading[0]',
          columnKey: 'heading',
        },
        {
          funnelbackField: 'listMetadata.url[0]',
          columnKey: 'url',
        },
        {
          funnelbackField: 'listMetadata.summary[0]',
          columnKey: 'summary',
        },
        {
          funnelbackField: 'listMetadata.location',
          columnKey: 'location',
        },
        {
          funnelbackField: 'listMetadata.openDate[0]',
          columnKey: 'openDate',
        },
        {
          funnelbackField: 'listMetadata.closeDate[0]',
          columnKey: 'closeDate',
        },
        {
          funnelbackField: 'listMetadata.endTimestamp[0]',
          columnKey: 'endTimestamp',
        },
        {
          funnelbackField: 'listMetadata.alt[0]',
          columnKey: 'alt',
        },
        {
          funnelbackField: 'listMetadata.timeHeading[0]',
          columnKey: 'timeHeading',
        },
      ];
    default:
      return [];
  }
};
